import { Component, Input, OnInit } from '@angular/core';
import { BBResponseContainer } from '../carrier/response-container';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import * as cloneDeep from 'lodash/cloneDeep';
import * as omit from 'lodash/omit';
import { InboundFileProcessing } from '../masterdata/models/inboundFileProcessing';
import { SelectableLab } from '../carrier/selectable-lab';

@Component({
  selector: 'app-inbound-file-processing',
  templateUrl: './inbound-file-processing.component.html',
  styleUrls: ['./inbound-file-processing.component.css']
})
export class InboundFileProcessingComponent implements OnInit {

  _masterLists: Array<InboundFileProcessing>;

  _labOptions: Array<LabMDM>;

  @Input() set masterLists(masterLists: Array<InboundFileProcessing>) {
    this._masterLists = (masterLists || []).map((inbound: InboundFileProcessing) => {
      return Object.assign({}, inbound, { handler: this.getSelectedHandler(inbound) });
    });
  }

  @Input() tableCols: Array<InboundFileProcessing>;

  @Input() title: string;

  @Input() set labOptions(input: LabMDM[]) {
    this._labOptions = input.filter((lab: LabMDM) => lab.name === this.checkSelectedLab.lab.name);
  }

  @Input() checkSelectedLab: SelectableLab;

  errorHandler: ErrorHandler = new ErrorHandler();

  handlers: Array<any>;

  selectedInboundProcessing: any;

  inboundFileProcessing: InboundFileProcessing;

  showInboundFileProcessingDialog: boolean;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
    this.showError = this.showError.bind(this);
  }

  ngOnInit() {
    this.handlers = [
      { name: 'FastFinder V3', value: 'FAST_FINDER_V3' },
      { name: 'FastFinder V4', value: 'FAST_FINDER_V4' },
      { name: 'First Result LC - json', value: 'FIRST_RESULT_LC_JSON' },
      { name: 'First Result LC - csv', value: 'FIRST_RESULT_LC_CSV' }
    ];
  }

  handleRowSelect(event: any) {
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    const { handler = '' } = data;
    this.inboundFileProcessing = cloneDeep(data);
    this.inboundFileProcessing.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.inboundFileProcessing.handler = this.handlers.find((fileFormatItem: any) => fileFormatItem.name === handler);
    this.showInboundFileProcessingDialog = true;
  }

  handleAddNewInboundFileProcessing() {
    this.inboundFileProcessing = { active: false };
    this.showInboundFileProcessingDialog = true;
  }

  handleSaveOrUpdate() {
    const { _id } = this.inboundFileProcessing;
    if (this.isValid()) {
      const inboundFileProcessing: InboundFileProcessing = Object.assign({}, this.inboundFileProcessing, { handler: ((this.inboundFileProcessing.handler || {}) as any).value });
      if (_id) {
        this._masterDataService.updateInboundFileProcessing(inboundFileProcessing).subscribe((response: BBResponseContainer) => {
          const { data } = response;
          data.handler = this.getSelectedHandler(data);
          const selectedInboundFileIndex: number = this._masterLists.findIndex((inboundItem: InboundFileProcessing) => inboundItem._id === _id);
          this._masterLists[selectedInboundFileIndex] = data;
          this.showInboundFileProcessingDialog = false;
        }, this.showError);
      } else {
        this._masterDataService.saveInboundFileProcessing(inboundFileProcessing).subscribe((response: BBResponseContainer) => {
          const { data } = response;
          data.handler = this.getSelectedHandler(data);
          this._masterLists.push(data);
          this.showInboundFileProcessingDialog = false;
        }, this.showError);
      }
    }
  }

  showError(error: any) {
    const { status } = error;
    if (status === 400) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Duplicate Key',
        detail: error.error.message
      });
    } else {
      let message = this.errorHandler.handleError(error);
      this._messageService.addErrorMessage(message);
    }
  }

  isValid() {
    const { name = '', handler, location = '', lab } = this.inboundFileProcessing;
    this.inboundFileProcessing = omit(this.inboundFileProcessing, ['nameError', 'locationError', 'labError', 'handlerError']);
    if (!name.trim().length) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Name',
        detail: 'Name cannot be empty'
      });
      (this.inboundFileProcessing as any).nameError = true;
      return false;
    } else if (!lab) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Lab',
        detail: 'Please select the Lab'
      });
      (this.inboundFileProcessing as any).labError = true;
      return false;
    } else if (!handler) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'File Format',
        detail: 'Please select Handler'
      });
      (this.inboundFileProcessing as any).handlerError = true;
      return false;
    } else if (!location.trim().length) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Folder Name',
        detail: 'Location Name cannot be empty'
      });
      (this.inboundFileProcessing as any).locationError = true;
      return false;
    }
    return true;
  }

  private getSelectedHandler(inboundFileProcessing: InboundFileProcessing) {
    const { handler } = inboundFileProcessing;
    const selectedHandler: any = this.handlers.find((format: any) => format.value === handler);
    return (selectedHandler || {}).name;
  }
}
